app.directive('video', function ($window, $document, throttle) {
    var getScrollParent = function (element, includeHidden) {
        var style = getComputedStyle(element);
        var excludeStaticParent = style.position === "absolute";
        var overflowRegex = includeHidden ? /(auto|scroll|hidden)/ : /(auto|scroll)/;

        if (style.position === "fixed") return document.body;
        for (var parent = element; (parent = parent.parentElement);) {
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === "static") {
                continue;
            } else if (excludeStaticParent) {
                // We've hit an element that is no longer static, positioning is now based on that one.
                excludeStaticParent = false;
            }
            if (overflowRegex.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }

        return document.body;
    };

    return {
        restrict: 'E',
        link: function ($scope, $element, $attrs) {
            var autoplayOnScroll = $attrs.autoplayOnScroll || false;

            if (autoplayOnScroll !== true && autoplayOnScroll !== "true" && autoplayOnScroll !== "autoplay-on-scroll") {
                return;
            }

            var scrollParent = angular.element(getScrollParent($element.get(0)));

            var testElement = function () {
                var isVisible = $element.visible(true, false, 'both', scrollParent);

                if (isVisible) {
                    $element.get(0).play();
                } else {
                    $element.get(0).pause();
                }
            };

            var eventParent = scrollParent;
            if (scrollParent.is('body')) {
                eventParent = angular.element($window);
            }

            eventParent.on('scroll', throttle(100, function () {
                testElement();
            }));

            setTimeout(function () {
                testElement();
            }, 1);
        }
    };
});